import React, { useEffect, useState } from "react";

function Footer({ companyName = "xdata", website = "https://xdata.uz" }) {
	const [time, setTime] = useState("");

	useEffect(() => {
		const interval = setInterval(() => {
			const now = new Date();
			const year = now.getFullYear();
			const hours = String(now.getHours()).padStart(2, "0");
			const minutes = String(now.getMinutes()).padStart(2, "0");
			const seconds = String(now.getSeconds()).padStart(2, "0");

			setTime(`${year} | ${hours}:${minutes}:${seconds}`);
		}, 1000);

		return () => clearInterval(interval);
	}, []);

	return (
		<footer
			className="
        fixed bottom-0 left-0 w-full
        flex items-center justify-center
        text-xs sm:text-sm
        bg-white/10 backdrop-blur-xl
        border-t border-white/20
        shadow-[0_-4px_15px_rgba(0,0,0,0.3)]
        py-2 sm:py-3 px-4
      "
		>
			<p className="text-gray-200 font-light tracking-wide text-center">
				© {time} . This platform is designed and developed by{" "}
				<a
					href={website}
					target="_blank"
					rel="noreferrer"
					className="font-medium text-indigo-400 hover:text-indigo-300 transition"
				>
					{companyName}
				</a>
				.
			</p>
		</footer>
	);
}

export default Footer;
